import { render } from "./TaskList.vue?vue&type=template&id=0068416a"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/TaskList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0068416a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0068416a', __exports__)) {
    api.reload('0068416a', __exports__)
  }
  
  module.hot.accept("./TaskList.vue?vue&type=template&id=0068416a", () => {
    api.rerender('0068416a', render)
  })

}


export default __exports__